/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function FfmpegTemplatesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $routeParams: JS5Object,
    $route: JS5Object,
    $location: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    FfmpegTemplatesService: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
) {
    this.editData = {
    };
    const getData = () => {
        this.loadingIndicator.show = true;
        FfmpegTemplatesService.getFfmpegTemplate($routeParams.id).then((ffmpegTemplate: JS5Object) => {
            FfmpegTemplatesService.originalEditData = _.cloneDeep(ffmpegTemplate);
            this.editData = ffmpegTemplate;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewFfmpegTemplate();
        }
        else {
            updateFfmpegTemplate();
        }
    };

    const updateFfmpegTemplate = () => {
        FfmpegTemplatesService.updateFfmpegTemplate(this.editData).then((ffmpegTemplate: JS5Object) => {
            FfmpegTemplatesService.originalEditData = _.cloneDeep(ffmpegTemplate);
            this.editData = ffmpegTemplate;
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewFfmpegTemplate = () => {
        FfmpegTemplatesService.createFfmpegTemplate(this.editData).then((ffmpegTemplate: JS5Object) => {
            $route.updateParams({id: ffmpegTemplate.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine') && _.size(_.get(this.editData, 'name')),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(FfmpegTemplatesService.originalEditData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/templates/search`).search({tab: 'FfmpegTemplates'})
        }
    ];


    this.$onInit = () => {
        SidebarService.editService = FfmpegTemplatesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit FFmpeg Template',
                        location: '/system/templates/search',
                        params: {tab: 'FfmpegTemplates'}
                    });
                }
                getData();
            } else {
                FfmpegTemplatesService.originalEditData = _.cloneDeep(this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Ffmpeg Template',
                    location: '/system/templates/search',
                    params: {tab: 'FfmpegTemplates'}
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        FfmpegTemplatesService.originalEditData = null;
        FfmpegTemplatesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            FfmpegTemplatesService.editorForm = this.editorForm;
            BreadcrumbService.editService = FfmpegTemplatesService;
        });
    };
}


angular.module('prism-ui.ffmpegTemplate').component('ffmpegTemplatesEditView', {
    templateUrl: 'system/templates/ffmpegTemplate/editor/ffmpeg-template-edit-template.html',
    controller: FfmpegTemplatesEditViewController,
    bindings: {
    }
});
